import TimeUtil from 'utils/time-util'

const initialValues = (cmsStoryGroup) => ({
  title                  : cmsStoryGroup?.title || '',
  thumbnail_cms_image_id : cmsStoryGroup?.thumbnail_cms_image?.id || '',
  is_active              : cmsStoryGroup?.is_active || false,
  starts_at              : TimeUtil.format(cmsStoryGroup?.starts_at, 'YYYY-MM-DD') || '',
  expires_at             : TimeUtil.format(cmsStoryGroup?.expires_at, 'YYYY-MM-DD') || '',
  starts_time            : cmsStoryGroup?.starts_at
    ? TimeUtil.format(cmsStoryGroup?.starts_at, 'HH:mm')
    : '00:00',
  expires_time: cmsStoryGroup?.expires_at
    ? TimeUtil.format(cmsStoryGroup?.expires_at, 'HH:mm')
    : '00:00',
  stories: getCmsStories(cmsStoryGroup?.stories) || []
})

const getCmsStories = (stories) => {
  if (!stories) return
  const newArr = []
  stories.map((story) => {
    newArr.push({
      id            : story?.id,
      cms_media_id  : story?.cms_media?.id,
      button_text   : story?.button_text,
      link_url_path : story?.link_url_path
    })
  })
  return newArr
}
export default initialValues